var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(this.$store.state.layout,{tag:"component"}),_c('snackbar',{attrs:{"props":_vm.$store.state.snackbarProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }